(function () {
  var root = document.querySelector("[data-marketing-signup]");
  if (!root) return;

  var endpoint = root.getAttribute("data-endpoint");
  var modal = root.querySelector("[data-marketing-signup-modal]");
  var closeBtn = modal.querySelector("[data-marketing-signup-close-btn]");
  var lastSubmit = null;

  function openModal() {
    modal.hidden = false;
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    modal.hidden = true;
    if (lastSubmit) lastSubmit.focus();
  }

  modal.addEventListener("click", function (event) {
    if (event.target.hasAttribute("data-marketing-signup-dismiss")) closeModal();
  });

  if (closeBtn) closeBtn.addEventListener("click", closeModal);

  document.addEventListener("keydown", function (event) {
    if (modal.hidden) return;
    if (event.key === "Escape") closeModal();
    if (event.key === "Tab") {
      event.preventDefault();
      if (closeBtn) closeBtn.focus();
    }
  });

  root.querySelectorAll("form").forEach(function (form) {
    var errorEl = form.querySelector("[data-marketing-signup-error]");
    var submitBtn = form.querySelector("[type='submit']");
    var emailInput = form.querySelector("[name='email']");
    var nameInput = form.querySelector("[name='name']");
    var companyInput = form.querySelector("[name='company']");
    var listInput = form.querySelector("[name='list_slug']");

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = "";
      }

      if (!emailInput.value || !emailInput.checkValidity()) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = "Please enter a valid email address.";
        }
        emailInput.focus();
        return;
      }

      lastSubmit = submitBtn;
      submitBtn.disabled = true;

      fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          list_slug: listInput ? listInput.value : "",
          email: emailInput.value,
          name: nameInput ? nameInput.value : "",
          company: companyInput ? companyInput.value : "",
        }),
      })
        .then(function (response) {
          return response.json().then(
            function (body) {
              return { ok: response.ok, body: body };
            },
            function () {
              return { ok: false, body: null };
            }
          );
        })
        .then(function (result) {
          if (result.ok && result.body && result.body.ok === true) {
            if (nameInput) nameInput.value = "";
            emailInput.value = "";
            openModal();
            return;
          }
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent = "Something went wrong. Please try again.";
          }
        })
        .catch(function () {
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent = "Something went wrong. Please try again.";
          }
        })
        .then(function () {
          submitBtn.disabled = false;
        });
    });
  });
})();
